import React from 'react'
import axios from 'axios'
import swal from 'sweetalert'

import { connect } from 'react-redux'
import { Button, Modal, FormControl, ControlLabel, FormGroup, Alert } from 'react-bootstrap'
import { handleErrorFetchingData } from '../../../functions/errorHandling'
import { removeInitialLogin } from '../../login/reducers/manageLogin'
import getServerURL from '../../../functions/getServerURL'

class InitialLoginModal extends React.Component {

  state = {
    initialLoginModal: this.props.currentUser.initial_login,
    oldPassword: "",
    newPassword: "",
    confirmNewPassword: "",
    error: ""
  }

  newPasswordLengthValidation = () => {
    const length = this.state.newPassword.length;
    if (length > 10) return 'success';
    if (length > 7) return 'warning';
    if (length > 0) return 'error';
    return null;
  }

  newPasswordMatchValidation = () => {
    if (this.state.confirmNewPassword.length) {
      if (this.state.confirmNewPassword === this.state.newPassword) {
        return 'success'
      } else {
        return 'error'
      }
    }
    return null
  }

  handleHide = () => this.setState({ initialLoginModal: false })

  handleInput = (e) => this.setState({ [e.target.name]: e.target.value })

  handleSubmitPasswordChange = () => {
    const { oldPassword, newPassword, confirmNewPassword } = this.state
    const { currentUser } = this.props
    let error = ''

    if (!oldPassword) {
      error = "Please enter your current password"
      return this.setState({ error })
    }

    if (!newPassword || !confirmNewPassword) {
      error = "Please enter and confirm a new password"
      return this.setState({ error })
    }

    if (newPassword.length < 8 || confirmNewPassword.length < 8) {
      error = "Passwords must be at least 8 characters in length"
      return this.setState({ error })
    }

    if (newPassword !== confirmNewPassword) {
      error = "New passwords do not match"
      return this.setState({ error })
    }

    this.setState({ error: "" })
    swal({
      text: "Changing your password...",
      icon: require("../../../static/images/spinner.gif"),
      button: false
    })
    axios({
      method:"PUT",
      headers: {"Authorization": "Bearer " + localStorage.getItem("token")},
      url: `${getServerURL()}change-password/`,
      data: {
        username: currentUser.username,
        old_password: oldPassword,
        new_password: newPassword,
      }
    })
    .then(response => {
      this.setState({ initialLoginModal: false }, () => {
        this.props.removeInitialLogin()
        swal({
          title: "Success!",
          text: `Password has been changed!`,
          icon: "success",
          button: "Continue!",
        })
      })
    })
    .catch(error => {
      const data = error.response.data
      if (data.old_password) {
        const errorMessage = data.old_password.join(' ')
        handleErrorFetchingData(error, errorMessage)
      } else if (data.new_password) {
        const errorMessage = data.new_password.join(' ')
        handleErrorFetchingData(error, errorMessage)
      }
    })
  }


  render () {
    const { error } = this.state

    return (
      <Modal
        show={ this.state.initialLoginModal }
        onHide={this.handleHide}
        aria-labelledby="contained-modal-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-lg">Initial Login</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h3>Welcome to PTOR</h3>
          <h4>For security purposes please change your password</h4>
          <br/>
          <div>
            <form>
              <FormGroup
                controlId="current-password"
              >
                <ControlLabel>Current Password</ControlLabel>
                <FormControl
                  type="password"
                  value={ this.state.oldPassword }
                  placeholder="Enter current password"
                  onChange={ this.handleInput }
                  name="oldPassword"
                />
                <FormControl.Feedback />
              </FormGroup>
              <FormGroup
                controlId="new-password"
                validationState={ this.newPasswordLengthValidation() }
              >
                <ControlLabel>New Password <span>(must be at least 8 characters long)</span></ControlLabel>
                <FormControl
                  type="password"
                  value={ this.state.newPassword }
                  placeholder="Enter new password"
                  onChange={ this.handleInput }
                  name="newPassword"
                />
                <FormControl.Feedback />
              </FormGroup>
              <FormGroup
                controlId="confirm-new-password"
                validationState={ this.newPasswordMatchValidation() }
              >
                <ControlLabel>Confirm New Password</ControlLabel>
                <FormControl
                  type="password"
                  value={ this.state.confirmNewPassword }
                  placeholder="Confirm new password"
                  onChange={ this.handleInput }
                  name="confirmNewPassword"
                />
                <FormControl.Feedback />
              </FormGroup>
            </form>
            { error ?
              <Alert bsStyle="danger">
                { error }
              </Alert>
              :
              null
             }
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="primary" onClick={ this.handleSubmitPasswordChange }>Submit</Button>
          <Button onClick={ this.handleHide }>Hide Message</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

const mapStateToProps = state => {
  return {
    currentUser: state.manageLogin.user
  }
}

export default connect(mapStateToProps, { removeInitialLogin })(InitialLoginModal);



// WEBPACK FOOTER //
// ./src/routes/projects/components/InitialLoginModal.js